var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSonde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1480 1831 c0 -26 3 -29 48 -35 146 -19 261 -138 279 -285 5 -48 7 -51 34 -51 26 0 29 3 29 34 0 54 -37 157 -75 208 -19 27 -56 64 -83 83 -49 36 -153 75 -203 75 -25 0 -29 -4 -29 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 1671 c0 -26 4 -29 42 -35 58 -9 125 -76 134 -134 6 -38 9 -42 35 -42 25 0 29 4 29 28 0 35 -41 121 -71 149 -32 29 -107 63 -141 63 -24 0 -28 -4 -28 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447 1502 c-33 -36 -8 -92 40 -92 25 0 53 30 53 57 0 46 -62 69 -93 35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 1360 c-64 -39 -63 -27 -63 -582 0 -481 1 -504 20 -535 39 -64 27 -63 580 -63 553 0 541 -1 580 63 19 31 20 54 20 535 0 555 1 543 -63 582 -31 19 -54 20 -537 20 -483 0 -506 -1 -537 -20z m1007 -130 c0 -6 -75 -10 -205 -10 -130 0 -205 4 -205 10 0 6 75 10 205 10 130 0 205 -4 205 -10z m0 -50 c0 -6 -75 -10 -205 -10 -130 0 -205 4 -205 10 0 6 75 10 205 10 130 0 205 -4 205 -10z m-694 -674 c25 -24 34 -43 34 -66 0 -23 -9 -41 -34 -66 -46 -46 -86 -46 -132 0 -46 46 -46 86 0 132 46 46 86 46 132 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonde);
export default __webpack_public_path__ + "static/media/sonde.e04db06e4ae6b66a2ce2fc312e91ea28.svg";
export { ForwardRef as ReactComponent };